
import React from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "../../components/common/LoginForm";
import "../../styles/login.css";

const Login = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = (role) => {
    switch (role?.toLowerCase()) {
      case "employee":
        navigate("/employee/dashboard");
        break;

      case "manager":
        navigate("/manager/dashboard");
        break;

      case "rh":
        navigate("/rh/dashboard");
        break;

      default:
        console.error("Rôle utilisateur non reconnu :", role);
        break;
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-centered-container">
       

        <LoginForm
          onLoginSuccess={handleLoginSuccess}
        />
      </div>
    </div>
  );
};

export default Login;
